import { render, staticRenderFns } from "./RelativeCallRecord.vue?vue&type=template&id=ac6feee0&scoped=true"
import script from "./RelativeCallRecord.vue?vue&type=script&lang=js"
export * from "./RelativeCallRecord.vue?vue&type=script&lang=js"
import style0 from "./RelativeCallRecord.vue?vue&type=style&index=0&id=ac6feee0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac6feee0",
  null
  
)

export default component.exports